// Unregistered answers "logged out, still loading": features stay gated.
const UNREGISTERED = {
    isLoggedIn: () => false,
    paid: () => false,
    lastImportedAt: () => undefined,
    status: () => "idle",
};
let access = UNREGISTERED;
export const setUserAccess = (next) => {
    access = next;
};
export const userAccess = {
    isLoggedIn: (state) => access.isLoggedIn(state),
    paid: (state) => access.paid(state),
    lastImportedAt: (state) => access.lastImportedAt(state),
    status: (state) => access.status(state),
};
//# sourceMappingURL=userAccessPort.js.map